import { useEffect, useState } from "react";
import { Lock, Printer } from "lucide-react";
import { api } from "../lib/api";
import { PageHeader, NeonButton, Panel } from "../components/common";
import { Markdown } from "../components/PartnershipNav";

export default function Partnership() {
  const [d, setD] = useState(null);
  const [denied, setDenied] = useState(false);
  useEffect(() => { api.get("/private/partnership").then((r) => setD(r.data)).catch(() => setDenied(true)); }, []);
  if (denied) return <p className="text-white/50" data-testid="partnership-denied">Page not found.</p>;
  if (!d) return <p className="font-mono text-xs text-white/40">loading…</p>;
  return (
    <div className="print-root" data-testid="partnership-page">
      <PageHeader eyebrow="// private · visible only to Oliver and Brennen" title="Partnership Agreement">
        <NeonButton variant="ghost" onClick={() => window.print()} data-testid="partnership-print"><Printer className="w-3 h-3" /> Print / save PDF</NeonButton>
      </PageHeader>
      <p className="flex items-center gap-2 text-xs text-white/45 mb-6"><Lock className="w-3 h-3" />No other merchant, partner or teammate can open this page. Every view is written to the audit log.</p>
      <Panel title="AEGIS Guard × Sharpr Picks" testid="partnership-agreement-panel"><Markdown text={d.agreement} testid="partnership-agreement" /></Panel>
      {d.talking_points && <div className="mt-6"><Panel title="Your private notes: talking points (only you see this section)" testid="partnership-notes-panel"><Markdown text={d.talking_points} testid="partnership-talking-points" /></Panel></div>}
    </div>
  );
}
